import React from 'react';
import type ProductsJsmKbPermissionsType from '@atlassian/jira-spa-apps-products-jsm-kb-permissions/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmKbPermissions = lazyForPaint<typeof ProductsJsmKbPermissionsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-kb-permissions", jiraSpaEntry: "async-products-jsm-kb-permissions" */ '@atlassian/jira-spa-apps-products-jsm-kb-permissions'
		),
	),
);

const AsyncProductsJsmKbPermissions = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmKbPermissions}
		pageId="products-jsm-kb-permissions"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmKbPermissions;
